import Box from '@mui/material/Box';
import {useEffect} from 'react';
import {useUserInfo} from '../../../hooks';
import {useTicketsFiltersContainer} from '../hooks/useTicketsFiltersContainer';
import {TicketsListFilterDepartment} from './TicketsListFilterAssigneeDepartment';

export const TicketsListViewDeptQueuesFilters = () => {
  const {isErpUser, department} = useUserInfo();
  const {setDepartmentFilter} = useTicketsFiltersContainer();
  useEffect(() => {
    if (!department) {
      return;
    }
    setDepartmentFilter(department);
  }, [department]);
  return (
    <Box display="flex" px={1} justifyContent="flex-start" alignItems="center" flexWrap="wrap">
      {isErpUser && (
        <>
          <TicketsListFilterDepartment />
        </>
      )}
    </Box>
  );
};
